import { render, staticRenderFns } from "./xiaoqu.vue?vue&type=template&id=ef424732&scoped=true"
import script from "./xiaoqu.vue?vue&type=script&lang=js"
export * from "./xiaoqu.vue?vue&type=script&lang=js"
import style0 from "./xiaoqu.vue?vue&type=style&index=0&id=ef424732&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef424732",
  null
  
)

export default component.exports